import { DROP, Original } from 'components/common';
import { getDropFromContractAddress } from './dropsHelpers';
import { toHexSeed } from './token';

// note: leavnig this here for reference. This is from utils in serverless code.
//
// const getGenesisAttributes = (seed: string, original: boolean) => {
//   const INNER_SHAPES_KEYS = ['square', 'squareCircle', 'squareDiamond', 'circle'];
//   const gridLengthLever = parseInt(seed.substr(0, 2), 16);
//   const horizontalLever = parseInt(seed.substr(2, 2), 16);
//   const diagonalLever = parseInt(seed.substr(4, 2), 16);
//   const paletteLever = parseInt(seed.substr(6, 2), 16);
//   const innerShapeLever = parseInt(seed.substr(8, 2), 16);

//   const gridLength = gridLengthLever + 7;
//   const xOffset = diagonalLever + horizontalLever + 2;
//   const yOffset = diagonalLever + 1;
//   const innerShape = INNER_SHAPES_KEYS[innerShapeLever];

//   const sharedAttributes = [
//     {
//       trait_type: 'Matrix Seed',
//       value: `${gridLengthLever}`,
//     },
//     {
//       trait_type: 'Run Rise Seed',
//       value: `${diagonalLever}`,
//     },
//     {
//       trait_type: 'Run Seed',
//       value: `${horizontalLever}`,
//     },
//     {
//       trait_type: 'Matrix',
//       value: `${gridLength}`,
//     },
//     {
//       trait_type: 'Run',
//       value: `${xOffset}`,
//     },
//     {
//       trait_type: 'Rise',
//       value: `${yOffset}`,
//     },
//     {
//       trait_type: 'Palette',
//       value: `${paletteLever}`,
//     },
//     {
//       trait_type: 'Geometry',
//       value: `${innerShape}`,
//     },
//     {
//       trait_type: 'Type',
//       value: original ? 'Original' : 'Print',
//     },
//     {
//       trait_type: 'Max Supply',
//       value: original ? '1' : '120',
//     },
//   ];

//   const extraAttributes: any = [];
//   if (original) {
//     extraAttributes.push({
//       trait_type: 'Royalty',
//       value: '8%',
//     });
//   }

//   return [...sharedAttributes, ...extraAttributes];
// };

const getShape = (originalId: string) => {
  const INNER_SHAPES_KEYS = ['square', 'squareCircle', 'squareDiamond', 'circle'];
  const hexSeed = toHexSeed(DROP.genesis, originalId);
  const innerShapeLever = parseInt(hexSeed.slice(-2), 16);
  return INNER_SHAPES_KEYS[innerShapeLever];
};

export function getRarity(beat: Original): string {
  const drop = getDropFromContractAddress(beat.contractAddress);
  if (drop !== 'genesis') return '';

  const shape = getShape(beat.id);
  if (shape === 'circle') {
    return 'Rare';
  }
  return 'Very Rare';
}
